// extracted by mini-css-extract-plugin
export default {"custom-checkbox":"checkbox_custom-checkbox__2eZhZ","small":"checkbox_small__oikzL","green":"checkbox_green__pNumB","lightgreen":"checkbox_lightgreen__9EN0B"};